export default __webpack_public_path__ + "static/media/24.fc247bf8.jpg";